import Image from '../../../../atoms/Image';
import Text from '../../../../atoms/Text';
import trending from '../../../../assets/images/flash_empty.svg';
import watchlist from '../../../../assets/images/watchlist_up.svg';
import swap from '../../../../assets/images/swap_grey.svg';

interface ISidebarNavigationProps {
  onTrending(): void;
  onWatchlist(): void;
  onTrading(): void;
}

const SidebarNavigation = ({
  onTrending,
  onWatchlist,
  onTrading,
}: ISidebarNavigationProps) => {
  return (
    <div className='global_sidebar_mobile__tabs'>
      <div className='global_sidebar_mobile__tabs__tab' onClick={onTrending}>
        <div className='global_sidebar_mobile__tabs__tab__icon'>
          <Image size='s' src={trending} />
        </div>
        <Text size={16} className='text--weight-500 text--grey-400'>
          Trending
        </Text>
      </div>
      <div className='global_sidebar_mobile__tabs__tab' onClick={onWatchlist}>
        <div className='global_sidebar_mobile__tabs__tab__icon'>
          <Image size='s' src={watchlist} />
        </div>
        <Text size={16} className='text--weight-500 text--grey-400'>
          Watchlist
        </Text>
      </div>
      <div className='global_sidebar_mobile__tabs__tab' onClick={onTrading}>
        <div className='global_sidebar_mobile__tabs__tab__icon'>
          <Image size='s' src={swap} />
        </div>
        <Text size={16} className='text--weight-500 text--grey-400'>
          Swap
        </Text>
      </div>
    </div>
  );
};

export default SidebarNavigation;
